<template>
    <div>
        <p v-if="hasNoStatusHits" aria-live="polite" class="hiq-detail-planning-list__hit-count">
            {{ emptyStatusText }}
        </p>
        <p v-else-if="totalHits > 0 && selectedFilters.length > 0" aria-live="polite" class="hiq-detail-planning-list__hit-count" v-html="hitCountText">
        </p>
        <div v-else-if="totalHits === 0" aria-live="polite">
            <h2 class="hiq-detail-planning-list__no-hits-heading">
                {{translations.noHitsHeading}}
            </h2>
            <p v-if="suggestion">
                {{translations.didYouMean}} "<a @click="searchSuggestion(suggestion.replace(/\*/g, ''))" href="#">{{suggestion.replace(/\*/g, '')}}</a>"?
            </p>
            <p>
                {{translations.tryThis}}
                <ul>
                    <li>{{translations.checkSpelling}}</li>
                    <li>{{translations.trySynonym}}</li>
                </ul>
            </p>
        </div>
    </div>
</template>
<script lang="ts">
import Vue from "vue";
import { searchSuggestion } from "../store/actions";
import { IFilter, ITranslations } from "../store/state";

interface HitCountComputed {
  totalHits: number;
  showingHits: number;
  hitCountText: string;
  suggestion?: string;
  translations: ITranslations;
  selectedFilters: IFilter[];
  selectedStatuses: IFilter[];
  hasNoStatusHits: boolean;
  emptyStatusText: string;
  amountOfShowingHits: number;
}
interface HitCountMethods {
  searchSuggestion(suggestion: string): void;
}

export default Vue.extend<{}, HitCountMethods, HitCountComputed, {}>({
  name: "HitCount",
  computed: {
    selectedFilters() {
      return [
        ...this.$store.getters.areaFilter,
        ...this.$store.getters.statusFilter,
      ].filter((filter: IFilter) => filter.selected);
    },
    selectedStatuses() {
      return this.$store.getters.statusFilter.filter(
        (filter: IFilter) => filter.selected
      );
    },
    hasNoStatusHits() {
      return this.totalHits === 0 && this.selectedStatuses.length > 0;
    },
    emptyStatusText() {
      return this.translations.noPlansForStatus;
    },
    totalHits() {
      let total = 0;
      const filteredHits = this.$store.getters.filteredHits;
      Object.keys(filteredHits).forEach((area) => {
        total += filteredHits[area].length;
      });
      return total;
    },
    showingHits() {
      return this.$store.getters.showingHits;
    },
    hitCountText() {
      return this.amountOfShowingHits > 1
        ? `<strong>${this.amountOfShowingHits} ${this.translations.hits}</strong> ${this.translations.matchingYourQuery}`
        : `<strong>${this.amountOfShowingHits} ${this.translations.hit}</strong> ${this.translations.matchingYourQuery}`;
    },
    suggestion() {
      return this.$store.getters.suggestion;
    },
    translations() {
      return this.$store.getters.translations;
    },
    amountOfShowingHits() {
      return this.$store.getters.amountOfShowingHits;
    },
  },
  methods: {
    searchSuggestion(suggestion) {
      this.$store.dispatch(searchSuggestion(suggestion));
    },
  },
});
</script>
